import React from "react";
import { Flex, Modal, Typography } from "antd";
import i18next from "i18next";
import { OrderSuccessfulIcon } from "svg";
type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const SuccessModal: React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <Modal
      open={isOpen}
      centered
      destroyOnClose
      okButtonProps={{ style: { margin: 0, width: "100%" } }}
      cancelButtonProps={{ style: { display: "none" } }}
      onOk={onClose}
      onCancel={onClose}
      styles={{ body: { justifyContent: "center" } }}
    >
      <>
        <Flex justify="center">
          <OrderSuccessfulIcon />
        </Flex>
        <Typography.Title level={3}>
          {i18next.t("order_has_been_successful")}
        </Typography.Title>
      </>
    </Modal>
  );
};

export default SuccessModal;
